module.exports = __webpack_public_path__ + "img/email.4deb4277.png";